import React from "react";
import { ResponsiveBar } from "@nivo/bar";
import { ResponsiveLine } from "@nivo/line";
import BarChartToolTip from "common-ui-components/components/tool-tip/BarChartToolTip";
import LineChartTooltip from "common-ui-components/components/tool-tip/LineChartToolTip";

const MiniTrendChart = ({ data, type, color }) => (
  <>
    {type === "line" ? (
      <ResponsiveLine
        data={data}
        tooltip={LineChartTooltip}
        margin={{ top: 6, right: 5, bottom: 10, left: 5 }}
        xScale={{ type: "point" }}
        yScale={{ type: "linear", min: "auto", max: "auto" }}
        colors={() => color}
        curve="monotoneX"
        enableGridX={false}
        enableGridY={false}
        axisTop={null}
        axisRight={null}
        axisBottom={null}
        axisLeft={null}
        enableArea
        areaOpacity={0.12}
        enablePoints
        pointSize={4}
        pointBorderWidth={0}
        pointColor={color}
        pointBorderColor={color}
        useMesh
        animate={false}
      />
    ) : (
      <ResponsiveBar
        data={data}
        tooltip={BarChartToolTip}
        keys={["value"]}
        indexBy="label"
        margin={{ top: 3, right: 2, bottom: 0, left: 2 }}
        padding={0.45}
        innerPadding={2}
        borderRadius={4}
        colors={{ datum: "data.color" }}
        axisTop={null}
        axisRight={null}
        axisBottom={null}
        axisLeft={null}
        enableGridY={false}
        enableLabel={false}
        animate={false}
      />
    )}
  </>
);

export default MiniTrendChart;
